import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Droplet, Zap, Shield, TrendingUp, Users, Award } from 'lucide-react';
import './HomePage.css';

import vid from '../assets/vid.mov';

const HomePage = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;
  const companyPhone = process.env.REACT_APP_COMPANY_PHONE;

  const services = [
    {
      icon: <Droplet size={32} />,
      title: 'Oil Exploration',
      description: 'Advanced upstream operations with cutting-edge exploration technologies'
    },
    {
      icon: <Zap size={32} />,
      title: 'Refining & Processing',
      description: 'State-of-the-art refining facilities delivering premium petroleum products'
    },
    {
      icon: <Shield size={32} />,
      title: 'Safety & Compliance',
      description: 'Industry-leading HSE programs ensuring operational excellence'
    },
    {
      icon: <TrendingUp size={32} />,
      title: 'Distribution & Trading',
      description: 'Global distribution network with efficient logistics solutions'
    }
  ];

  const stats = [
    { value: '10+', label: 'Years of Experience' },
    { value: '2.5M', label: 'Barrels Per Day' },
    { value: '150+', label: 'Projects Completed' },
    { value: '4000+', label: 'Skilled Workforce' }
  ];

  const projects = [
    {
      title: 'Offshore Platform Expansion',
      location: 'Baltic Sea',
      image: 'https://images.unsplash.com/photo-1578356058390-f58c575337a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxvZmZzaG9yZSUyMG9pbCUyMHJpZ3xlbnwwfHx8fDE3NjUxMzMzNTR8MA&ixlib=rb-4.1.0&q=85',
      capacity: '150,000 BPD'
    },
    {
      title: 'Refinery Modernization',
      location: 'Gdansk, Poland',
      image: 'https://images.unsplash.com/photo-1588011930968-eadac80e6a5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxvaWwlMjByZWZpbmVyeXxlbnwwfHx8fDE3NjUxMzMzNDl8MA&ixlib=rb-4.1.0&q=85',
      capacity: '200,000 BPD'
    },
    {
      title: 'Pipeline Infrastructure',
      location: 'Central Europe',
      image: 'https://images.unsplash.com/photo-1507823690283-48b0929e727b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwxfHxvaWwlMjBwaXBlbGluZXxlbnwwfHx8fDE3NjUxMzMzNjh8MA&ixlib=rb-4.1.0&q=85',
      capacity: '800 km'
    }
  ];

  return (
    <div className="home-page">
      <section className="hero-section">
	  
        <div  className="hero-overlay">
			<video autoPlay muted loop src={vid}></video> 	
		</div>
		
		<div style={{ zIndex:'1', height: '100%', minWidth: '100%'}} className="hero-overlay"></div>
		
        <div className="hero-content">
          <h1 className="hero-title">Powering Tomorrow's Energy Solutions</h1>
          <p className="hero-subtitle">
            Leading oil exploration and refinery operations with several years of excellence in sustainable energy production
          </p>
          <div className="hero-cta">
            <Link to="/services" className="btn-primary">
              Explore Our Services
              <ArrowRight size={20} />
            </Link>
            <Link to="/contact" className="btn-secondary">
              Get in Touch
            </Link>
          </div>
        </div>
      </section>

      <section className="services-section section">
        <div className="container">
          <h2 className="section-title">Our Core Services</h2>
          <p className="section-subtitle">
            Comprehensive energy solutions from exploration to distribution
          </p>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <Link to="/services" className="service-link">
                  Learn More <ArrowRight size={16} />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-preview-section">
        <div className="container">
          <div className="about-preview-grid">
            <div className="about-preview-image">
			
              <img
                src="https://images.unsplash.com/photo-1516937941344-00b4e0337589?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxvaWwlMjByZWZpbmVyeXxlbnwwfHx8fDE3NjUxMzMzNDl8MA&ixlib=rb-4.1.0&q=85"
                alt="Refinery Operations"
              />
			  
            </div>
            <div className="about-preview-content">
              <h2>About Us</h2>
              <p>
                For many years now, we've been at the forefront of oil exploration and refining excellence. Our commitment to operational safety, environmental stewardship, and technological innovation drives everything we do.
              </p>
              <p>
                With state-of-the-art facilities and a dedicated team of industry experts, we deliver reliable energy solutions that power communities and industries worldwide.
              </p>
              <div className="about-features">
                <div className="about-feature">
                  <Users size={24} />
                  <div>
                    <h4>Expert Team</h4>
                    <p>1000+ skilled professionals</p>
                  </div>
                </div>
                <div className="about-feature">
                  <Award size={24} />
                  <div>
                    <h4>Industry Leadership</h4>
                    <p>Certified and compliant</p>
                  </div>
                </div>
              </div>
              <Link to="/about" className="btn-primary">
                Learn More About Us
                <ArrowRight size={20} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-card">
                <h3 className="stat-value">{stat.value}</h3>
                <p className="stat-label">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="projects-section section">
        <div className="container">
          <h2 className="section-title">Featured Projects</h2>
          <p className="section-subtitle">
            Delivering excellence in energy infrastructure development
          </p>
          <div className="projects-grid">
            {projects.map((project, index) => (
              <div key={index} className="project-card">
                <div className="project-image">
                  <img src={project.image} alt={project.title} />
                  <div className="project-overlay">
                    <span className="project-capacity">{project.capacity}</span>
                  </div>
                </div>
                <div className="project-content">
                  <h3>{project.title}</h3>
                  <p className="project-location">{project.location}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="projects-cta">
            <Link to="/projects" className="btn-primary">
              View All Projects
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>

      <section className="contact-cta-section">
        <div className="container">
          <div className="contact-cta-content">
            <h2>Ready to Partner With Industry Leaders?</h2>
            <p>Connect with our team to discuss your energy needs and explore collaboration opportunities</p>
            <div className="contact-cta-buttons">
              <a href={`tel:${companyPhone}`} className="btn-primary">
                Call {companyPhone}
              </a>
              <Link to="/contact" className="btn-secondary">
                Contact Us Online
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;